export const checkIsDevEnvironment = () =>
  process.env.NODE_ENV === "development";
